// extracted by mini-css-extract-plugin
module.exports =  {"landingFeaturesCTA":"oE1WZkLP","title":"Q6Q4b_7M","boltIcon":"LtdExtli","button":"v8busgqm"};